var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M19.5 2.5h-16c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h9v-2h-9v-10l8 5 8-5v5h2v-7c0-1.1-.9-2-2-2zm-8 7l-8-5h16l-8 5zm7 4l4 4-4 4v-3h-4v-2h4v-3z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }